import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40b9cc51"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "check-list" }
const _hoisted_3 = { class: "btn-area" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("保存")

import { ref, watch, PropType } from 'vue'
import { getRecordActionTemplateDetail } from '@/api/shop'
import { useStore } from 'vuex'
import { IQuestion } from '@/utils/interface'
import { Toast } from 'vant'


export default /*#__PURE__*/_defineComponent({
  props: {
  templateId: {
    type: String,
    require: true
  },
  checkedList: {
    type: Array as PropType<IQuestion[]>,
    default() {
      return []
    }
  }
},
  emits: ['saveData'],
  setup(__props, { emit }) {

const props = __props

const active = ref(1)
const value = ref('')

const list = ref<IQuestion[]>([])
const detailInfo = ref<any[]>([])
const store = useStore()

const activeName = ref(0)
const activeName2 = ref([0])

const searchData = () => {
  if (value.value) {
    list.value = oldData.filter(
      (item: IQuestion) => item.questionName.indexOf(value.value) !== -1
    )
  } else {
    list.value = JSON.parse(JSON.stringify(oldData))
  }
}



watch(
  () => props.templateId,
  (newVal: any) => {
    if (newVal) {
      getData()
    }
  }
)

watch(
  () => props.checkedList,
  (newVal: IQuestion[]) => {
    checkedList.value = JSON.parse(JSON.stringify(newVal))
  }
)



const checkItem = (ques: IQuestion) => {
  const index = checkedList.value.findIndex(
    (item: IQuestion) => item.questionId === ques.questionId
  )
  if (index === -1) {
    checkedList.value.push(ques)
  } else {
    checkedList.value.splice(index, 1)
  }
}

const checkedList = ref<IQuestion[]>([])
let oldData: IQuestion[] = []

let level = 0
const getData = () => {
  getRecordActionTemplateDetail({
    thirdTenantId: store.getters.thirdTenantId,
    templateId: props.templateId
  }).then((res: any) => {
    level = res.auditPersonLevel
    const arr: any[] = []
    res.detailInfo.forEach((item: any) => {
      item.itemList.forEach((item2: any) => {
        // @ts-ignore
        arr.push(...item2.questionList)
      })
    })
    list.value = arr
    oldData = JSON.parse(JSON.stringify(arr))

    detailInfo.value = res.detailInfo
  })
}
getData()

const resetData = () => {
  checkedList.value = []
  emit('saveData', [], 0)
}

const saveData = () => {
  if (!checkedList.value.length) {
    Toast.fail('请选择数据')
    return
  }
  const ids = checkedList.value.map((item: IQuestion) => item.questionId)
  const data: any = []
  detailInfo.value.forEach((item: any, index: number) => {
    data[index] = {
      groupId: item.groupId,
      groupName: item.groupName,
      itemInfoList: []
    }
    item.itemList.forEach((item2: any, index2: number) => {
      // @ts-ignore
      const checkList = item2.questionList
        .filter((item3: IQuestion) => ids.indexOf(item3.questionId) !== -1)
        .map((item4: IQuestion) => ({
          questionId: item4.questionId,
          scoreChange: item4.score,
          questionName: item4.questionName
        }))
      if (checkList.length) {
        data[index].itemInfoList[index2] = {
          itemId: item2.itemId,
          itemName: item2.itemName,
          questInfoList: checkList
        }
      }
      if (index2 === item.itemList.length - 1) {
        if (!data[index].itemInfoList.length) {
          data.splice(index, 1)
        }
        if (data[index]) {
          data[index].itemInfoList = data[index].itemInfoList.filter(
            (item: any) => item
          )
        }
      }
    })
  })
  emit(
    'saveData',
    checkedList.value,
    level,
    data.filter((item: any) => item)
  )
}

return (_ctx: any,_cache: any) => {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_collapse_item = _resolveComponent("van-collapse-item")!
  const _component_van_collapse = _resolveComponent("van-collapse")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(checkedList.value.length
          ? `问题项：${checkedList.value.length} 得分：${checkedList.value
              .map((item) => item.score)
              .reduce((a, b) => a + b)}`
          : '请选择点检问题'), 1),
    _createVNode(_component_van_tabs, {
      active: active.value,
      "onUpdate:active": _cache[3] || (_cache[3] = ($event: any) => ((active).value = $event)),
      swipeable: "",
      style: {"padding-bottom":"50px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_tab, {
          name: 1,
          title: "按问题"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_search, {
              modelValue: value.value,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
                searchData
              ],
              placeholder: "请输入问题项名称搜索"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_van_cell_group, { inset: "" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_van_cell, {
                    onClick: ($event: any) => (checkItem(item)),
                    key: index,
                    title: item.questionName,
                    value: item.score,
                    icon: 
              checkedList.value.find((item2) => item2.questionId === item.questionId)
                ? 'checked'
                : 'circle'
            
                  }, null, 8, ["onClick", "title", "value", "icon"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_van_tab, {
          name: 2,
          title: "按层级"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_tabs, {
              active: activeName.value,
              "onUpdate:active": _cache[2] || (_cache[2] = ($event: any) => ((activeName).value = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailInfo.value, (item) => {
                  return (_openBlock(), _createBlock(_component_van_tab, {
                    key: item.id,
                    title: `${item.groupName}`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_collapse, {
                        modelValue: activeName2.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeName2).value = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item['itemList'], (item2, index2) => {
                            return (_openBlock(), _createBlock(_component_van_collapse_item, {
                              key: item2.itemId,
                              name: index2,
                              title: `${item2.itemName}`
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_van_cell_group, null, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2.questionList, (item3) => {
                                      return (_openBlock(), _createBlock(_component_van_cell, {
                                        key: item3.questionId,
                                        onClick: ($event: any) => (checkItem(item3)),
                                        title: item3.questionName,
                                        value: item3.score,
                                        icon: 
                      checkedList.value.find(
                        (item4) => item4.questionId === item3.questionId
                      )
                        ? 'checked'
                        : 'circle'
                    
                                      }, null, 8, ["onClick", "title", "value", "icon"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["name", "title"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["title"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["active"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["active"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_van_button, {
        onClick: resetData,
        class: "btn-area-item",
        color: "#FFB881"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_van_button, {
        onClick: saveData,
        class: "btn-area-item",
        color: "#FD5504"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ])
  ]))
}
}

})